export default {
  computed: {
    isMerchantAdmin() {
      return this.$role.verify([this.$role.MERCHANT_ADMIN]);
    },
    isFeatureEnabled() {
      return this.$store.getters.verifyFeature(
        this.$role.FEATURES.PROMOTIONAL_CODES
      );
    },
    canViewPromocodes() {
      return (
        this.isFeatureEnabled &&
        (this.isMerchantAdmin ||
          this.$role.verify([this.$role.VIEW_PROMOCODES]))
      );
    },
    canEditOrCreatePromocodes() {
      return (
        this.isFeatureEnabled &&
        (this.isMerchantAdmin ||
          this.$role.verify([this.$role.CREATE_PROMOCODES]))
      );
    },
    canDeletePromocodes() {
      return (
        this.isFeatureEnabled &&
        (this.isMerchantAdmin ||
          this.$role.verify([this.$role.DELETE_PROMOCODES]))
      );
    }
  }
};
